
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --body-font-size:var(--fs-body-sm);
  --body-color:var(--brand-gray-900);
}

:host([active]) .accordion-panel--content{
    display:flex;
    flex-direction:column;
    gap:var(--spacing-4);
  }

outline-styled-text-baseline *{
  --body-color:var(--brand-gray-900);
}

.accordion-panel{
  display:flex;
  flex-direction:column;
  width:100%;
  border-bottom:2px solid var(--brand-gray-400);
  margin-bottom:var(--spacing-4);
}

.accordion-panel--heading{
  display:flex;
  width:100%;
  justify-content:space-between;
  padding-bottom:var(--spacing-4);
  cursor:pointer;
}

.accordion-panel--heading:hover .accordion-panel--button::after{
        outline-width:4px;
      }

.accordion-panel--button{
  background-color:var(--brand-bright-blue-900);
  padding:var(--spacing-2);
  border:0px solid;
  width:-moz-fit-content;
  width:fit-content;
  transition:all 0.2s ease-in;
  outline-color:var(--brand-dark-blue-900);
  outline-style:solid;
  outline-offset:8px;
  outline-width:0px;
  position:relative;
}

.accordion-panel--button::after{
    transition:all 0.2s ease-in;
    content:'';
    position:absolute;
    top:0;
    left:0;
    height:100%;
    width:100%;
    outline:solid 0px var(--brand-bright-blue-900);
  }

.accordion-panel--button:hover::after{
      outline-width:4px;
    }

.accordion-panel--button:focus{
    outline-width:4px;
  }

.accordion-panel--button:focus::after{
      outline-width:4px;
    }

.accordion-panel--label{
  display:flex;
  align-items:center;
}

.accordion-panel--icon{
  color:var(--brand-dark-blue-900);
  color:var(--accordion-panel-icon-color, var(--brand-dark-blue-900));
}

.accordion-panel--content{
  display:none;
  padding:var(--spacing-6);
  background-color:var(--brand-gray-200);
  margin-bottom:var(--spacing-4);
}
`;